import React, { FC, ReactElement, useContext } from 'react';
import { ThemeModeContext } from '@pentester.com/grommet-theme';
import { Image } from 'grommet';

interface Props {
  src: string;
}

// TODO: Needs refactoring. Awful design. Every single image should be a component and only colors need to be changed.
export const ThemeModeImage: FC<Props> = ({ src }): ReactElement => {
  const { mode } = useContext(ThemeModeContext);
  return (
    <Image
      style={{ zIndex: 1 }}
      src={`${src.split(`.`)[0]}_${mode}.${src.split(`.`)[1]}`}
      alt={src.split(`.`)[0]}
    />
  );
};
